// TODO: Unify the naming of the providers with their plain value inorder to use them as enums and improve typing.
// e.g. "WPI_NEQUI", "WPI_PSE", "WPI_BANCOLOMBIA", "WPI_BANCOLOMBIA_CORRESPONSAL", "WPI_BOTON_DAVIPLATA", "FELIX".
// Fix Boleto.
export const Providers = {
  /**
   * This is a copy of the FE SDK enum PaymentProviderTypes
   * Please keep this updated.
   * */
  // Brazil
  ASAAS: "ASAAS",
  ASAAS_BOLETO: "ASAAS_BOLETO", // Not in FE
  ASAAS_PIX: "ASAAS_PIX",
  // Colombia
  BANCOLOMBIA: "BANCOLOMBIA",
  EFECTY: "EFECTY",
  MOVII: "MOVII",
  REFACIL: "REFACIL",
  WOMPI: "WOMPI",
  WOMPI_BANCOLOMBIA_CORRESPONSAL: "WPI_BANCOLOMBIA_CORRESPONSAL",
  WOMPI_BOTON_BANCOLOMBIA: "WPI_BANCOLOMBIA",
  WOMPI_DAVIPLATA: "WPI_BOTON_DAVIPLATA",
  WOMPI_NEQUI: "WPI_NEQUI",
  WOMPI_PSE: "WPI_PSE",
  // Ecuador
  KUSHKI: "KUSHKI",
  MONNET: "MONNET",
  RED_ACTIVA: "RED_ACTIVA",
  // Indonesia
  VIRTUAL_ACCOUNT: "VIRTUAL_ACCOUNT",
  XENDIT: "XENDIT",
  // México
  BITSO: "BITSO",
  CODI: "CODI",
  FELIX_PAGO: "FELIX",
  OXXO: "OXXO",
  OXXO_DIRECT: "OXXO_DIRECT",
  PESPAY: "PESPAY",
  SIX: "SIX",
  STP: "STP",
  // Panama
  CLAVE: "CLAVE",
  MULTIPAGOS: "MULTIPAGOS",
  PUNTO_PAGO: "PUNTO_PAGO",
  WESTERN_UNION: "WESTERN_UNION",
  // Peru
  BCP: "BCP",
  INTERBANK: "INTERBANK",
  KASNET: "KASNET",
  KASNET_QR: "KASNET_QR",
  // Phillipines
  D_LOCAL: "D_LOCAL",
  D_LOCAL_GCASH: "D_LOCAL_GCASH",
  D_LOCAL_MAYA: "D_LOCAL_MAYA",
  D_LOCAL_SEVEN_ELEVEN: "D_LOCAL_SEVEN_ELEVEN",
  // South Africa
  FLASH: "FLASH",
  // Others
  IN_STORE: "IN_STORE",
  OPENPAY: "OPENPAY",
  SPEI: "SPEI",
  STRIPE: "STRIPE",
};

export type PaymentProviderType = (typeof Providers)[keyof typeof Providers];
